import { render, staticRenderFns } from "./WhatsappAuth.vue?vue&type=template&id=22aba52d&scoped=true"
import script from "./WhatsappAuth.vue?vue&type=script&lang=js"
export * from "./WhatsappAuth.vue?vue&type=script&lang=js"
import style0 from "./WhatsappAuth.vue?vue&type=style&index=0&id=22aba52d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aba52d",
  null
  
)

export default component.exports